import { createThemeCompiler } from '../../../utils';

export const colorPickerThemeCompiler = createThemeCompiler(({ palette, borderRadius, boxShadow, stroke }) => ({
    colorPicker: {
        colors: {
            knob: {
                backgroundColor: palette.white,
                borderColor: palette.neutralTertiary
            },
            pickerSurfaceBorderColor: palette.neutralTertiary
        },
        composites: {
            knob: {
                borderRadius: borderRadius.circle,
                borderWidth: stroke.thin,
                boxShadow: boxShadow.m
            },
            pickerSurface: {
                borderRadius: borderRadius.curvedSmall,
                borderWidth: stroke.none,
                boxShadow: boxShadow.none
            }
        }
    }
}));
